import { render, staticRenderFns } from "./TransactionsChallenge.vue?vue&type=template&id=51b731da&scoped=true&"
import script from "./TransactionsChallenge.vue?vue&type=script&lang=js&"
export * from "./TransactionsChallenge.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsChallenge.vue?vue&type=style&index=0&id=51b731da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b731da",
  null
  
)

export default component.exports